import './styles.scss'
import React from 'react'

import {
  ConversationAddress,
  PluginPayment,
  ClubSaludPlugin,
  PluginMarketingSales,
  AutomatizationPlugin,
  PluginProgramMessage,
  PluginResources,
  PluginNauta,
  PluginSurveys,
  PluginLabels,
  PluginEcommerce,
  ConversationViewPlugin,
  PluginTrackingUserInfo,
  PluginTrackingHistory,
  PluginRedirect,
  PluginTopicSummary
} from '../../Plugins'
import dkvConfiguration from 'constants/dkv.constants'
import { getStaticImage } from 'utils/statics'

const POST_CHANNELS = ['instagram_post', 'facebook_post', 'twitter_post']

const ChatChannelPlugins = ({ isOpen, toggle, user, operator, plugins, setting, composer, dispatch, channel }) => {
  return (
    <div
      className={`
        chat-channel-plugins
        ${!isOpen ? 'chat-channel-plugins--closed' : ''}
      `}
    >
      <button
        className={`
          chat-channel-plugins__toggle-panel-btn
          ${!isOpen ? 'chat-channel-plugins__toggle-panel-btn--closed' : ''}
        `}
        onClick={toggle}
      >
        <figure>
          <img src={getStaticImage('/icons/orange-brand/icon-arrow-back-dark.svg')} alt='Toggle plugins panel' />
        </figure>
      </button>
      <div className='chat-channel-plugins__content-container'>
        <div className='chat-channel-plugins__content'>
          <ConversationViewPlugin />
          <PluginProgramMessage composer={composer} isRemoveByUser={user.isRemoveByUser} />
          <AutomatizationPlugin user={user} setting={setting} />
          <PluginLabels data={{ user, operator }} />
          <PluginResources
            resourceType="sharedFiles"
            isRemoveByUser={user.isRemoveByUser}
          />
          <PluginResources
            resourceType="resources"
            isRemoveByUser={user.isRemoveByUser}
          />
          <PluginPayment plugins={plugins.payment} user={user} />
          {!POST_CHANNELS.includes(channel) && <PluginMarketingSales user={user} />}
          {!POST_CHANNELS.includes(channel) && <ConversationAddress userId={user.id} isRemoveByUser={user.isRemoveByUser} />}
          {dkvConfiguration.isDKV && <ClubSaludPlugin plugins={plugins.payment} user={user} />}
          {dkvConfiguration.isDKV && <PluginNauta user={user} />}
          <PluginSurveys data={{ user, operator }} dispatch={dispatch} />
          <PluginEcommerce
            userId={user.id}
            isRemoveUser={user.isRemoveByUser}
          />
          {setting.isRedirectPluginEnabled && <PluginRedirect userId={user.id} />}
          {['chatweb'].includes(channel) && <PluginTrackingUserInfo userId={user.id} />}
          {['chatweb'].includes(channel) && <PluginTrackingHistory userId={user.id} />}
          {
            !POST_CHANNELS.includes(channel)
              ? (
                <PluginTopicSummary
                  userId={user.id}
                  isRemoveUser={user.isRemoveByUser}
                />
              ) : null
          }
        </div>
      </div>
    </div>
  )
}

export default ChatChannelPlugins
